<template>
    <div>
        <div
            @click="open = !open"
            class="p-4 rounded-t-xl bg-white border border-stone-200 shadow-xs cursor-pointer"
            :class="{ 'border-b-0': open, 'rounded-b-xl border-b': !open }"
        >
            <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <div
                        v-if="iconName"
                        class="p-2"
                    >
                        <Icon
                            :name="iconName"
                            class="w-5 h-5 text-gray-500"
                        />
                    </div>
                    <div>
                        <div class="text-gray-900">
                            {{ title }}
                        </div>
                        <div class="text-xs text-gray-700">
                            {{ subtitle }}
                        </div>
                    </div>
                </div>
                <div class="p-2">
                    <Icon
                        v-if="open"
                        name="angle-up"
                        class="w-4 h-4 text-gray-500"
                    />
                    <Icon
                        v-else
                        name="angle-down"
                        class="w-4 h-4 text-gray-500"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="open"
            :class="{ 'pb-6': slots.actions }"
            class="px-6 rounded-b-xl bg-white border border-stone-200 border-t-0 shadow-xs"
        >
            <div>
                <slot name="content" />
            </div>
            <div class="mt-6 flex justify-end">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, useSlots } from 'vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        iconName: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: null,
        },
        open: {
            type: Boolean,
            default: false,
        },
    })

    const open = ref<boolean>(props.open)
    const slots: any = useSlots()
</script>
